import { CONTACT_INFORMATION } from './footer';

export const NETWORK_ERROR_GENERIC = `There is a connection problem.
Please try again later or contact support [${CONTACT_INFORMATION.split('|')[0].split(':')[1]}]`;
